export default "__VITE_ASSET__DgTEDNcX__"